'use strict';

require('./build/buildDateRangeUnitsCall');

// This package does not export anything as it is
// simply defining "years" on Range.prototype.


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/range/years.js
// module id = 435
// module chunks = 1